// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__J3Cjo","separator":"Breadcrumb_separator__WZulg","link":"Breadcrumb_link__lQUkN","current":"Breadcrumb_current__tYpbb"};